/* eslint-disable */
export const bpdata = {
  'testEnd':1630071161,
  'testStart':1630071155,
  'productType':'EBM1',
  'sys': 125,
  'dia': 80,
  'hr': 101,
  'afib': true
}



// WEBPACK FOOTER //
// ./src/_helpers/backend-data/test-data/bpdata.js